import { VirtualMcVoiceType } from '@/src/types/VirtualMcVoiceType';
import _, { random } from 'lodash';

export const getCountdownAudio = (voice: VirtualMcVoiceType, timeRemaining: number) => {
  const parts = [_.lowerCase(voice), timeRemaining, timeRemaining === 1 ? 'minute' : 'minutes', random(1, 10)];
  const file = `/assets/countdowns/${parts.join('_')}.mp3`;

  return new Audio(file);
};
